import { generatePath } from 'react-router-dom';
import { IMarketAward, MarketAwardSource } from './interface';
import { isBefore } from 'date-fns';
import _ from 'lodash';

/**
 * A market award is considered as expired when
 * the event for it would be ended by this time
 */
export function isMarketAwardExpired(marketAward: IMarketAward) {
    const now = new Date();
    return isBefore(marketAward.end, now);
}

export function makeUrlForMarketAwardDispatchEvent(dispatchId: string) {
    return generatePath(`/events/history?marketAwardDispatchId=${dispatchId}`);
}

export function calcMarketAwardEarnings(marketAward: IMarketAward) {
    if (marketAward.price == null) return null;

    const ms = new Date(marketAward.end).valueOf() - new Date(marketAward.start).valueOf();
    const hours = ms / 1000 / 60 / 60;
    const earnings = marketAward.mw * hours * marketAward.price;

    return earnings;
}

/**
 * market awards must be in the same resource
 * market award must be consecutive in timing
 * cannot combine day ahead with real time
 * real time can be combined: fmm can be combined with rtd
 */
export function canCombineAndApprove(marketAwards: IMarketAward[]): [result: true] | [result: false, error: Error] {
    if (marketAwards.length < 2) {
        const errorMessage = 'Cannot combine one market award. Select two or more.';
        console.info(`[canCombineAndApprove] `, errorMessage);
        return [false, new Error(errorMessage)];
    }

    const isSameResource = marketAwards.every(it => it.resourceName === marketAwards[0].resourceName);
    if (!isSameResource) {
        const errorMessage = 'Cannot combine market awards as they have different resources';
        console.info(`[canCombineAndApprove] `, errorMessage);
        return [false, new Error(errorMessage)];
    }

    const isExpectedSourceCombination =
        marketAwards.every(it => it.source === MarketAwardSource.DAM) ||
        marketAwards.every(it => [MarketAwardSource.FMM, MarketAwardSource.RTD].includes(it.source));
    if (!isExpectedSourceCombination) {
        const errorMessage = 'Cannot combine day ahead and real-time market awards';
        console.info(`[canCombineAndApprove] `, errorMessage);
        return [false, new Error(errorMessage)];
    }

    marketAwards = _.orderBy(marketAwards, ['start'], ['asc']);

    let isConsecutive = true;
    let prev = marketAwards[0];
    marketAwards.forEach((it, index) => {
        if (index === 0) return;
        if (it.start !== prev.end) isConsecutive = false;
        prev = { ...it };
    });

    if (!isConsecutive) {
        const errorMessage = 'Cannot combine market awards as they are not consecutive';
        console.info(`[canCombineAndApprove] `, errorMessage);
        return [false, new Error(errorMessage)];
    }

    return [true];
}
